import Swal from "sweetalert2";
import theme from "../theme/theme";
export const errorResponseHandler = (title, msg) => {
  const fallback = "Something went wrong. Please try again.";
  const text =
    typeof msg === "string" ? msg : (msg && typeof msg.message === "string" ? msg.message : fallback);
  return Swal.fire({
    icon: "error",
    title: title,
    text: text,
    confirmButtonText: "Close",
    confirmButtonColor: theme.palette.primary.main,
  });
};

export const successResponseHandler = (title, msg) => {
  return Swal.fire({
    icon: "success",
    title: title,
    text: msg,
    confirmButtonText: "Close",
  });
};
